import React from "react";
import { useTranslation } from "react-i18next";
import { Transition } from "react-transition-group";
import lotAngle from '../../Images/LotAngle.svg'

const AppProcedure = ({ isOpen, onClose }) => {
    const { t } = useTranslation()

    return (
        <Transition in={isOpen} timeout={300} unmountOnExit>
            {(state) => (
                <div
                    className={`fixed inset-0 z-50 flex items-center 
                                justify-center transition-opacity 
                                duration-300 
                     ${state === "entered" ? "opacity-100 backdrop-blur-sm"
                            : "opacity-0"
                        }`}
                    onClick={onClose}
                >
                    <div
                        style={{
                            transition: "transform 0.3s ease",
                            transform: state === "entered" ?
                                "translateY(0)" : "translateY(-100%)",
                        }}
                        className="bg-white dark:text-dark-text border-border-secondary
                                   dark:bg-dark-box p-8 news 
                                   shadow-md w-[95%] xl:w-[50%] overflow-y-auto max-h-[90vh]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="bg-primary rounded-md text-white p-4">
                            {t('app_procedurePhysical')}
                        </h2>
                        <ul className="text-left my-4 space-y-2">
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_province')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_district')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_appeal')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_name')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_surname')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_patronimic')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_address')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_phone')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_email')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_message')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="lotAngle" /> {t('app_file')}</li>
                        </ul>
                        <p className="text-left text-justify">
                           {t('app_procedureDefinition')}
                        </p>

                        <h2 className="font-bold text-primary mt-4">
                            {t('app_procedureJudicial')}
                        </h2>
                        <ul className="text-left mt-2 space-y-2">
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_organisation')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_position')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_province')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_district')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_appeal')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_name')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_surname')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_patronimic')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_address')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_phone')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_email')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_message')}</li>
                            <li className="flex items-center gap-2"><img src={lotAngle} alt="loTAngle" />{t('app_file')}</li>
                        </ul>

                        <div className="w-full text-center mt-4">
                            <button
                                className="w-max bg-red text-white py-1 px-4 rounded"
                                onClick={onClose}
                            >
                                {t('close')}
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </Transition>
    );
};


export default AppProcedure